import { message, Table } from 'antd';
import { FETCH_ERROR } from 'constants/alerts';
import { useEffect, useState } from 'react';
import { PushNotificationService } from 'services/PushNotificationService';
import { checkValue, formatDate } from 'utils';

function PushNotificationSendingsTable({ isActive, pushNotificationId }) {
  const [loading, setLoading] = useState(false);
  const [sendings, setSendings] = useState([]);

  useEffect(() => {
    fetchClientOfSegment();
  }, [isActive, pushNotificationId]);

  const fetchClientOfSegment = async () => {
    if (!isActive || !pushNotificationId) {
      return;
    }

    setLoading(true);

    try {
      const statistics = await PushNotificationService.getStatistics(
        pushNotificationId
      );

      setSendings(statistics);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Дата',
      dataIndex: 'send_date',
      render: (date) => (date ? formatDate(date) : '---'),
    },
    {
      title: 'Открыто',
      dataIndex: 'opened_sent',
      key: 'opened_sent',
      render: checkValue,
    },
    {
      title: 'Доставлено',
      dataIndex: 'delivered_send',
      key: 'delivered_send',
      render: checkValue,
    },
    {
      title: 'Не доставлено',
      dataIndex: 'failure_quantity',
      key: 'failure_quantity',
      render: checkValue,
    },
    {
      title: 'Всего',
      dataIndex: 'total_sent',
      key: 'total_sent',
      render: checkValue,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={sendings}
      loading={loading}
      rowKey="id"
      pagination={false}
    />
  );
}

export { PushNotificationSendingsTable };
